import { LogLevel } from '@studio/domain/logger';
import { Logger } from './logger';

// monkey-patch console.debug to be silent
const oldConsoleDebug = window['console']['debug'];
window['console']['debug'] = (): void => undefined;

export function initLogLevel(level: string, { production, sandbox, stage }): void {
    let logLevel: LogLevel = LogLevel.LOG;

    // environment defaults
    if (sandbox) {
        logLevel = LogLevel.WARN;
    } else if (production) {
        logLevel = LogLevel.ERROR;
    }

    switch (level) {
        case 'debug':
            logLevel = LogLevel.DEBUG;
            window['console']['debug'] = oldConsoleDebug;
            break;
        case 'log':
            logLevel = LogLevel.LOG;
            break;
        case 'verbose':
            logLevel = LogLevel.VERBOSE;
            break;
    }

    Logger.setLogLevel(logLevel);
    logSystemInformation(stage, production);
}

function logSystemInformation(stage: string, production: boolean): void {
    Logger.verbose(`App running in {${stage}} prod: ${production}`);
    Logger.verbose(`Log level set to ${Logger.getLogLevelName()}`);
    Logger.verbose('Type `bfstudio` in the console for more information!');
}
